var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar20X20 = function SvgCalendar20X20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.48 3.056c.383 0 .694.31.694.694v.695h.694c1.15 0 2.083.932 2.083 2.083v8.333c0 1.15-.932 2.084-2.083 2.084H5.146a2.083 2.083 0 0 1-2.083-2.084V6.528c0-1.15.932-2.083 2.083-2.083h.694V3.75a.694.694 0 1 1 1.39 0v.695h5.555V3.75c0-.383.31-.694.694-.694ZM15.561 10H4.453v4.861c0 .384.31.695.694.695h9.722c.384 0 .694-.311.694-.695v-4.86ZM5.84 5.834h-.694a.694.694 0 0 0-.695.694v2.083h11.111V6.528a.694.694 0 0 0-.694-.694h-.694v.694a.694.694 0 1 1-1.39 0v-.694H7.23v.694a.694.694 0 0 1-1.389 0v-.694Z",
    fill: "#008545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.531 12.778c0-.382.313-.694.695-.694.382 0 .694.312.694.694a.696.696 0 0 1-.694.694.696.696 0 0 1-.695-.694Zm3.473-.694h2.777c.382 0 .695.312.695.694a.696.696 0 0 1-.695.694h-2.777a.696.696 0 0 1-.695-.694c0-.382.313-.694.695-.694Z",
    fill: "#008545"
  })));
};
export default SvgCalendar20X20;